import type { NextPage } from 'next'
// import { useRouter } from 'next/router'
// import Link from 'next/link'
// import { useState } from 'react'

// import type { Item } from '@/modules/project'
import Dayjs from '@/components/dayjs'
import style from './item.module.css'

import AttachFileTable from './AttachFileTable'
import {EnvironmentalConservation, MainProposal} from "@/modules/project";
import BlankPage from "@/components/pages/project/blank";
import GGHeading4 from "@/components/title/GgHeading4";
import {useState} from "react";


interface IProps {
  className?: string
    items?: EnvironmentalConservation[]
}

interface IArrowProps {
  onClick?: () => void
}

interface IInfoProps {
  index: number
  item: EnvironmentalConservation
  activatedPageHandler: (pageNumber: number) => void
}

interface IInfoMainProps {
  index: number
  className: string
  item: EnvironmentalConservation
}

const Arrow: NextPage<IArrowProps> = ({onClick}) => {
  return (
    <div className='absolute flex justify-center items-center top-0 right-0 h-full w-[60px] cursor-pointer bg-[#009BFA]' onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="15.739" height="29.626" viewBox="0 0 15.739 29.626">
        <path d="M1522.346,1587.3a1.066,1.066,0,0,1,0-1.507l12.951-12.969-12.995-13.012a1.069,1.069,0,0,1,1.511-1.513l13.6,13.62a1.525,1.525,0,0,1-.022,1.819L1523.85,1587.3a1.063,1.063,0,0,1-1.5,0Z" transform="translate(-1521.989 -1557.989)" fill="#fff"/>
      </svg>
    </div>
  )
}

const InfoComponent: NextPage<IInfoProps> = ({index, item, activatedPageHandler}) => {

  return (
    <>
      {(item.type == "proposal") && (
        <tr>
          <th>협의 접수일 (본안)</th>
          <td><Dayjs format="dateDot">{item.registeredDatetime}</Dayjs></td>
          <th>협의 통보일 (본안)</th>
          <td className='relative'>
            <Dayjs format="dateDot">{item.noticeDatetime}</Dayjs>
            <Arrow onClick={() => activatedPageHandler(item.idx)}/>
          </td>
        </tr>
      )}
      {item.type == "improve" && (
        <tr>
          <th>협의 접수일 ({index}차)</th>
          <td><Dayjs format="dateDot">{item.registeredDatetime}</Dayjs></td>
          <th>협의 통보일 ({index}차)</th>
          <td className='relative'>
            <Dayjs format="dateDot">{item.noticeDatetime}</Dayjs>
            <Arrow onClick={() => activatedPageHandler(item.idx)}/>
          </td>
        </tr>
      )}
      {item.type == "result" && (
        <tr>
          <th>협의 접수일</th>
          <td><Dayjs format="dateDot">{item.registeredDatetime}</Dayjs></td>
          <th>협의결과 통보일</th>
          <td className='relative'>
            <Dayjs format="dateDot">{item.noticeDatetime}</Dayjs>
            <Arrow onClick={() => activatedPageHandler(item.idx)}/>
          </td>
        </tr>
      )}
    </>
  )
}


const InfoMainComponent: NextPage<IInfoMainProps> = ({index, className, item}) => {

  const getRegisteredItemName = (type: string): string => {
    switch(type) {
      case "proposal":
        return "협의 접수일 (본안)";
      case "improve":
        return `협의 접수일 (${index}차)`;
      case "result":
        return "협의 접수일"
      default:
        return "협의 접수일"
    }
  }

  const getNoticedItemName = (type: string): string => {
    switch(type) {
      case "proposal":
        return "협의 통보일 (본안)";
      case "improve":
        return `협의 통보일 (${index}차)`;
      case "result":
        return "협의결과 통보일"
      default:
        return "협의결과 통보일"
    }
  }

  return (
    <div className={className}>
      <div className='my-12'>
        <table className={`${style.baseInfoTable}`}>
          <colgroup>
            <col width={300}/>
            <col width={300}/>
            <col width={300}/>
            <col width={300}/>
          </colgroup>
          <tbody>
          <tr>
            <th>
              {getRegisteredItemName(item.type)}
            </th>
            <td><Dayjs format="dateDot">{item?.registeredDatetime}</Dayjs></td>
            <th>
              {getNoticedItemName(item.type)}
            </th>
            <td><Dayjs format="dateDot">{item?.noticeDatetime}</Dayjs></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div className='my-8'>
        <AttachFileTable title="환경보전방안서" items={item?.files? item.files: []}/>
      </div>
    </div>
  )
}


const Component: NextPage<IProps> = ({ className, items }) => {
  const title = "환경보전방안서";

  const [activatedPage, setActivatedPage] = useState(items && items.length > 0? items[0].idx: 0);

  const activatedPageHandler = (pageNumber: number) => {
    setActivatedPage(pageNumber);
  }

  return (
    <section className={className || ''}>
      <h3 className={style.h3}>
          {title}
      </h3>
      {
        items && items.length > 0?
          (
            <>
              <div>
                <table className={`${style.baseInfoTable} border-t-2 border-t-gg-blue`}>
                  <colgroup>
                    <col width={300}/>
                    <col width={300}/>
                    <col width={300}/>
                    <col width={300}/>
                  </colgroup>
                  <tbody>{items.map((EnvironmentalConservation, index) => (<InfoComponent key={EnvironmentalConservation.idx} item={EnvironmentalConservation} index={index} activatedPageHandler={activatedPageHandler}/>))}</tbody>
                </table>
              </div>
              {items.map((EnvironmentalConservation, index) => (
                <InfoMainComponent key={EnvironmentalConservation.idx} index={index} item={EnvironmentalConservation} className={activatedPage == EnvironmentalConservation.idx? "": "hidden"} />
              ))}
            </>
          )
          :
          (
              <BlankPage title={title} className="mb-12" />
          )
      }

    </section>
  )
}

export default Component
